<template>
  <div class="answering-dialog">
    <div class="box">
      <div class="close-btn" @click="$emit('closeDialog')">
        <div class="shadow"></div>
      </div>
      
      <div class="topic">解答思路</div>
      <div class="area" v-html="explanation"></div>
      
    </div>

    <showBigPhoto v-if="url" :url="url" @close="url = ''"></showBigPhoto>
  </div>
</template>

<script>
import showBigPhoto from './showBigPhoto.vue'

export default {
  props: ['explanation'],
  components: {
    showBigPhoto
  },
  data() {
    return {
      url: ''
    }
  },
  methods: {
    clickImg(url) {
      this.url = url
    }
  },
  mounted() {
    this.$nextTick(() => {
      let imgLists = document.querySelectorAll('.answering-dialog .area img')
      for(let i = 0; i < imgLists.length; i++) {
        let img = imgLists[i]
        // console.log(img.src)
        img.onclick = () => this.clickImg(img.src)
      }
      console.log(imgLists)
    })
  }
}
</script>

<style scoped lang="scss">
.answering-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .box {
    width: 60%;
    height: 60%;
    min-width: 800px;
    min-height: 500px;
    background-color: #fff;
    border-radius: 20px;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    position: relative;
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    .close-btn {
      position: absolute;
      top: -19px;
      right: -17px;
      width: 35px;
      height: 37px;
      border-radius: 50px;
      background-color: #b5282c;
      cursor: pointer;

      &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 65%;
        height: 4px;
        border-radius: 4px;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:after {
        transform: rotateZ(-45deg);
      }
      .shadow {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50px;
        box-shadow: inset 0 -4px 0 0 #841515;
        transition: box-shadow .1s linear;
      }

      &:hover {
        // opacity: .7;
        .shadow {
          box-shadow: inset 0 -1px 0 0 #841515;
        }
      }
    }

    .topic {
      width: 100%;
      text-align: center;
      font-size: 20px;
      color: #b5282c;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .area {
      flex: 1;
      width: 100%;
      background-color: #fff6ec;
      border-radius: 15px;
      padding: 10px 20px;
      box-sizing: border-box;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
}
</style>